import React, { useState } from 'react';
import ReactInterval from 'react-interval';
import { forgotPasswordEmail } from '../../store/action/user';
import { Button, Input } from "@biteship/atom";

const ForgotPassword = () => {
  const [values, setValues] = useState({
    email: '',
    password: '',
    error: '',
    loading: false,
    redirectToReferrer: false,
    emailSent: false
  });

  const handleChange = (name) => (event) => {
    setValues({ ...values, error: false, [name]: event.target.value });
  };

  const onSubmit = async () => {
    try {
      const res = await forgotPasswordEmail(values.email);
      if (res.success) {
        setValues({ ...values, emailSent: true, loading: false });
      } else {
        setValues({ ...values, error: res.error, loading: false });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const showError = () => (
    <div
      className="alert alert-danger"
      style={{ display: values.error ? '' : 'none' }}
    >
      {values.error}
    </div>
  );

  const onLoading = (e) => {
    setValues({ ...values, loading: true });
  };

  if (values.emailSent) {
    return (
      <div className="flex justify-center">
        <div className="w-1/3">
          <br />
          <br />
          <div className="card text-center">
            <br />
            <div className="items-center">
              <h2>
                <strong className="text-primary">
                  biteship
                </strong>
              </h2>
            </div>
            <br />
            <h6>
              Kami sudah kirimkan link password ke email Anda. Mohon dicek.
            </h6>
            <br />
            <a href="/">Kembali ke Menu Utama</a>
          </div>
        </div>

      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <ReactInterval
        timeout={2000}
        enabled={values.loading}
        callback={() => onSubmit()}
      />
      <div className="w-1/3">
        <br />
        <br />
        <div className="flex justify-center">
          <h1>
            <i>
              <img
                style={{ height: 72 }}
                src="/images/logos/biteship.png"
                alt=""
              />
            </i>
          </h1>
        </div>

        <br />

        <div className="card p-6">
          <h4>
            Lupa password?
          </h4>
          {showError()}
          <p>Masukkan email Anda yang terhubung dengan akun Biteship lalu kami akan mengirimkan link perubahan password.</p>
          <div>
            <label htmlFor="exampleInputEmail1">Email address</label>
            <Input
              type="text"
              onChange={handleChange('email')}
              placeholder="Email Anda"
              className="mb-4"
              values={values.email}
            />
          </div>

          <Button
            onClick={() => setValues({ ...values, loading: true })}
            loading={values.loading}
            className="full-center"
            title="Submit"
            loadingTitle="Submitting..."
          />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
